import { Loader2 } from 'lucide-react';

import { cn } from '~/utils/cn';

import { Icon } from '../Icon/view';
import { Text } from '../Text/view';
import type { ButtonVariant, PropsButton } from './interfaces';

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: 'bg-primary-01 text-intense-01 hover:opacity-95 active:opacity-90',
  secondary: 'bg-support-01 text-primary-01 hover:opacity-95',
  ghost: 'bg-transparent text-primary-01 hover:bg-intense-02',
  outline:
    'bg-transparent text-primary-01 border border-intense-03 hover:bg-intense-02',
  danger: 'bg-warning-04 text-intense-01 hover:opacity-95',
};

const ICON_COLOR: Record<ButtonVariant, string> = {
  primary: '#FFFFFF',
  secondary: '#1D4733',
  ghost: '#1D4733',
  outline: '#1D4733',
  danger: '#FFFFFF',
};

export default function Button({
  text,
  onClick,
  loading,
  disabled,
  variant = 'primary',
  className,
  textClassName,
  leftIcon,
  rightIcon,
  iconColor,
  type = 'button',
  fullWidth,
}: PropsButton) {
  const isDisabled = disabled || loading;
  const resolvedIconColor = iconColor ?? ICON_COLOR[variant];

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        'inline-flex items-center justify-center gap-nano h-[56px] px-medium rounded-small transition-opacity font-bold text-bodyLG',
        VARIANT_CLASS[variant],
        isDisabled && 'opacity-60 cursor-not-allowed',
        fullWidth && 'w-full',
        className,
      )}
    >
      {loading ? (
        <Loader2 className="animate-spin" size={20} color={resolvedIconColor} />
      ) : (
        <>
          {leftIcon && <Icon name={leftIcon} size={18} color={resolvedIconColor} />}
          {text && (
            <Text className={cn('text-paragraphLG', textClassName)}>{text}</Text>
          )}
          {rightIcon && <Icon name={rightIcon} size={18} color={resolvedIconColor} />}
        </>
      )}
    </button>
  );
}
